(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mood-selector"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const moodCards = document.querySelectorAll('.mood-card');
  const moodActionBtns = document.querySelectorAll('.mood-action-btn');

  // Fungsi untuk menangani klik kartu
  function handleCardClick(card) {
    // Hapus kelas 'selected' dari semua kartu
    moodCards.forEach(c => {
      c.classList.remove('selected');
    });

    // Tambahkan kelas 'selected' ke kartu yang diklik
    card.classList.add('selected');

    // Trigger any specific action based on mood
    const mood = card.dataset.mood;
    console.log(`Selected mood: ${mood}`);
  }

  // Event listener untuk kartu
  moodCards.forEach(card => {
    card.addEventListener('click', (e) => {
      // Cek apakah yang diklik bukan tombol aksi
      if (!e.target.closest('.mood-action-btn')) {
        handleCardClick(card);
      }
    });
  });

  // Event listener untuk tombol aksi
  moodActionBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation(); // Mencegah event menyebar ke kartu
      const card = btn.closest('.mood-card');
      handleCardClick(card);
      
      // Arahkan ke link yang ditentukan
      window.location.href = btn.getAttribute('href');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-svallet"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Cache DOM elements
  const mainImage = document.getElementById('main-product-image');
  const productImages = document.querySelectorAll('.product-image-item');
  const addToCartBtn = document.getElementById('add-to-cart');
  const wishlistBtn = document.getElementById('add-to-wishlist');
  const showMoreReviews = document.getElementById('show-more-reviews');
  const recommendationCheckboxes = document.querySelectorAll('.recommendation-checkbox');
  
  // Tab content elements
  const tabInfo = document.getElementById('tab-information');
  const tabOverview = document.getElementById('tab-overview');
  const informationContent = document.getElementById('information-content');
  const overviewContent = document.getElementById('overview-content');
  
  // Stars initialization
  initializeStars();
  
  // ==============================
  // Tab Navigation Functionality
  // ==============================
  if (tabInfo && tabOverview) {
    tabInfo.addEventListener('click', function() {
      // Update active tab
      tabInfo.classList.add('tab-active');
      tabOverview.classList.remove('tab-active');
      
      // Show/hide appropriate content
      if (informationContent && overviewContent) {
        informationContent.classList.remove('hidden');
        overviewContent.classList.add('hidden');
      }
    });
    
    tabOverview.addEventListener('click', function() {
      // Update active tab
      tabOverview.classList.add('tab-active');
      tabInfo.classList.remove('tab-active');
      
      // Show/hide appropriate content
      if (informationContent && overviewContent) {
        overviewContent.classList.remove('hidden');
        informationContent.classList.add('hidden');
      }
    });
  }

  // ==============================
  // Product Image Gallery Functionality - Simplified for better performance
  // ==============================
  if (productImages.length > 0) {
    productImages.forEach(img => {
      img.addEventListener('click', function() {
        // Remove active state from all images
        productImages.forEach(image => {
          image.querySelector('img').classList.remove('active-image');
        });
        
        // Add active state to clicked image
        this.querySelector('img').classList.add('active-image');
        
        // Update main product image with fade effect
        if (mainImage) {
          mainImage.style.opacity = '0';
          
          // Use requestAnimationFrame for smoother transitions
          requestAnimationFrame(() => {
            const newImageSrc = this.getAttribute('data-image');
            
            // Set timeout to reduce performance issues
            setTimeout(() => {
              mainImage.src = newImageSrc;
              mainImage.style.opacity = '1';
            }, 200);
          });
        }
      });
    });
  }

  // ==============================
  // Add to Cart Button Functionality - Optimized
  // ==============================
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      // Prevent default form submission only if we want to show the animation
      if (!document.querySelector('.ajax-cart-enabled')) return;
      
      e.preventDefault();
      
      // Save original button content
      const originalContent = this.innerHTML;
      
      // Update button to show success state
      this.innerHTML = '<span class="check-icon"></span> Added';
      this.classList.add('success');
      
      // Create a toast notification
      showToast('success', 'Product added to your cart!');
      
      // Reset button after 2 seconds
      setTimeout(() => {
        this.innerHTML = originalContent;
        this.classList.remove('success');
        
        // Submit the form after showing the animation
        if (this.closest('form')) {
          this.closest('form').submit();
        }
      }, 2000);
    });
  }

  // ==============================
  // Wishlist Button Functionality - Optimized
  // ==============================
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function() {
      const icon = this.querySelector('.heart-icon');
      if (!icon.classList.contains('active')) {
        // Add to wishlist
        icon.classList.add('active');
        this.classList.add('wishlist-active');
        
        // Create a toast notification
        showToast('info', 'Added to your wishlist!');
        
        // Send request to add to wishlist
        addToWishlist();
      } else {
        // Remove from wishlist
        icon.classList.remove('active');
        this.classList.remove('wishlist-active');
        
        // Create a toast notification
        showToast('warning', 'Removed from your wishlist');
        
        // Send request to remove from wishlist
        removeFromWishlist();
      }
    });
  }

  // ==============================
  // Show More Reviews Functionality - Optimized
  // ==============================
  if (showMoreReviews) {
    showMoreReviews.addEventListener('click', function() {
      const chevron = this.querySelector('.chevron-down, .chevron-up');
      
      if (chevron.classList.contains('chevron-down')) {
        // Change icon
        chevron.classList.remove('chevron-down');
        chevron.classList.add('chevron-up');
        this.textContent = 'Show less reviews ';
        this.appendChild(chevron);
        
        // Show toast notification
        showToast('info', 'Loading more reviews...');
        
        // Load more reviews
        loadMoreReviews();
      } else {
        // Change icon back
        chevron.classList.remove('chevron-up');
        chevron.classList.add('chevron-down');
        this.textContent = 'Show more reviews ';
        this.appendChild(chevron);
        
        // Show toast notification
        showToast('info', 'Showing fewer reviews');
        
        // Hide additional reviews
        hideAdditionalReviews();
      }
    });
  }

  // ==============================
  // Recommendation Checkbox Functionality - More visible
  // ==============================
  if (recommendationCheckboxes.length > 0) {
    recommendationCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const variantId = this.getAttribute('data-variant-id');
        const price = this.getAttribute('data-price');
        
        if (this.checked) {
          // Show toast notification
          showToast('success', 'Item added to your order');
          
          // Add complementary product to cart data
          addComplementaryItem(variantId, 1);
        } else {
          // Show toast notification
          showToast('info', 'Item removed from your order');
          
          // Remove complementary product from cart data
          removeComplementaryItem(variantId);
        }
      });
    });
  }

  // ==============================
  // Helper Functions - Optimized
  // ==============================
  
  // Function to initialize star ratings
  function initializeStars() {
    const starRatings = document.querySelectorAll('.star-rating, .review-rating');
    
    starRatings.forEach(container => {
      const rating = parseFloat(container.getAttribute('data-rating'));
      const stars = container.querySelectorAll('.star');
      
      stars.forEach((star, index) => {
        if (index < Math.floor(rating)) {
          star.classList.add('filled');
        }
      });
    });
  }
  
  // Function to show toast notifications - Simplified for better performance
  function showToast(type, message) {
    // Create toast container if it doesn't exist
    let toastContainer = document.querySelector('.toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.className = 'toast-container';
      document.body.appendChild(toastContainer);
    }
    
    // Create toast
    const toast = document.createElement('div');
    toast.className = 'toast';
    
    const alertClass = type === 'success' ? 'alert-success' : 
                      type === 'info' ? 'alert-info' : 'alert-warning';
    
    const iconClass = type === 'success' ? 'check-circle' :
                     type === 'info' ? 'info-circle' : 'exclamation-circle';
    
    toast.innerHTML = `
      <div class="alert ${alertClass}">
        <span class="${iconClass}"></span>
        <span>${message}</span>
      </div>
    `;
    
    toastContainer.appendChild(toast);
    
    // Use requestAnimationFrame for smoother transitions
    requestAnimationFrame(() => {
      // Show toast with animation
      setTimeout(() => {
        toast.classList.add('show');
      }, 10);
      
      // Remove toast after 2.5 seconds (faster to reduce lag)
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
          toast.remove();
        }, 300);
      }, 2500);
    });
  }
  
  // Function to add complementary item to cart
  function addComplementaryItem(variantId, quantity) {
    // Using Shopify's AJAX API to add item to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      // Update cart count and total if needed
      updateCartCounters();
    })
    .catch(error => {
      console.error('Error adding item:', error);
    });
  }
  
  // Function to remove complementary item from cart
  function removeComplementaryItem(variantId) {
    // Using Shopify's AJAX API to update the cart
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(data => {
      // Update cart count and total if needed
      updateCartCounters();
    })
    .catch(error => {
      console.error('Error removing item:', error);
    });
  }
  
  // Function to update cart counters
  function updateCartCounters() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update any cart counters on the page
      const cartCounters = document.querySelectorAll('.cart-count');
      cartCounters.forEach(counter => {
        counter.textContent = cart.item_count;
      });
    });
  }
  
  // Function to add to wishlist
  function addToWishlist() {
    // Implementation depends on your wishlist app or custom solution
    console.log('Added to wishlist');
  }
  
  // Function to remove from wishlist
  function removeFromWishlist() {
    // Implementation depends on your wishlist app or custom solution
    console.log('Removed from wishlist');
  }
  
  // Function to load more reviews - Simplified for better performance
  function loadMoreReviews() {
    // This would typically fetch more reviews via AJAX
    // For this example, we'll just simulate adding more reviews
    const reviewsList = document.querySelector('.reviews-list');
    
    if (reviewsList) {
      // Check if additional reviews are already loaded
      if (document.querySelector('.additional-reviews')) {
        document.querySelector('.additional-reviews').classList.remove('hidden');
        return;
      }
      
      // Create container for additional reviews
      const additionalReviews = document.createElement('div');
      additionalReviews.className = 'additional-reviews';
      
      // Add some sample reviews
      additionalReviews.innerHTML = `
        <div class="review-card">
          <div class="review-header">
            <p class="reviewer-name">Maria Gonzalez</p>
            <div class="review-rating" data-rating="5">
              <span class="star filled"></span>
              <span class="star filled"></span>
              <span class="star filled"></span>
              <span class="star filled"></span>
              <span class="star filled"></span>
            </div>
          </div>
          <p class="review-date">2 months ago</p>
          <p class="review-text">Excellent quality and fast shipping. Exactly what I needed!</p>
        </div>
        
        <div class="review-card">
          <div class="review-header">
            <p class="reviewer-name">John Edwards</p>
            <div class="review-rating" data-rating="3">
              <span class="star filled"></span>
              <span class="star filled"></span>
              <span class="star filled"></span>
              <span class="star"></span>
              <span class="star"></span>
            </div>
          </div>
          <p class="review-date">5 weeks ago</p>
          <p class="review-text">Good product but packaging could be improved. The lamp arrived with a small scratch.</p>
        </div>
      `;
      
      reviewsList.appendChild(additionalReviews);
      
      // Initialize stars in the new reviews
      const newRatings = additionalReviews.querySelectorAll('.review-rating');
      newRatings.forEach(container => {
        const rating = parseFloat(container.getAttribute('data-rating'));
        const stars = container.querySelectorAll('.star');
        
        stars.forEach((star, index) => {
          if (index < Math.floor(rating)) {
            star.classList.add('filled');
          }
        });
      });
    }
  }
  
  // Function to hide additional reviews
  function hideAdditionalReviews() {
    const additionalReviews = document.querySelector('.additional-reviews');
    if (additionalReviews) {
      additionalReviews.classList.add('hidden');
    }
  }
  
  // Set first image as active on page load
  if (productImages.length > 0) {
    const firstImage = productImages[0].querySelector('img');
    if (firstImage) {
      firstImage.classList.add('active-image');
    }
  }
  
  // Set transition for main image
  if (mainImage) {
    mainImage.style.transition = 'opacity 0.3s ease-in-out';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uki-promotions"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Set card indices for staggered animation
  const cards = document.querySelectorAll('#section-{{ section.id }} .value-card');
  cards.forEach((card, index) => {
    card.style.setProperty('--card-index', index);
  });
  
  // Initialize intersection observer for better performance
  if ('IntersectionObserver' in window) {
    const observerOptions = {
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.1
    };
    
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.visibility = 'visible';
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    cards.forEach(card => {
      observer.observe(card);
    });
  }
  
  // Handle horizontal scroll on touch devices
  const horizontalContainer = document.querySelector('#section-{{ section.id }} .horizontal-scroll');
  if (horizontalContainer) {
    // Add scroll indicators
    const scrollContainer = document.createElement('div');
    scrollContainer.className = 'scroll-indicators';
    scrollContainer.innerHTML = '<span class="scroll-left"></span><span class="scroll-right"></span>';
    horizontalContainer.parentNode.appendChild(scrollContainer);
    
    // Add scroll behavior
    let isDown = false;
    let startX;
    let scrollLeft;
    
    horizontalContainer.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - horizontalContainer.offsetLeft;
      scrollLeft = horizontalContainer.scrollLeft;
      horizontalContainer.style.cursor = 'grabbing';
    });
    
    horizontalContainer.addEventListener('mouseleave', () => {
      isDown = false;
      horizontalContainer.style.cursor = 'grab';
    });
    
    horizontalContainer.addEventListener('mouseup', () => {
      isDown = false;
      horizontalContainer.style.cursor = 'grab';
    });
    
    horizontalContainer.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - horizontalContainer.offsetLeft;
      const walk = (x - startX) * 2;
      horizontalContainer.scrollLeft = scrollLeft - walk;
    });
    
    // Update scroll indicators state
    function updateScrollIndicators() {
      const scrollIndicators = document.querySelector('#section-{{ section.id }} .scroll-indicators');
      if (!scrollIndicators) return;
      
      const isAtStart = horizontalContainer.scrollLeft < 10;
      const isAtEnd = horizontalContainer.scrollLeft + horizontalContainer.offsetWidth >= horizontalContainer.scrollWidth - 10;
      
      scrollIndicators.querySelector('.scroll-left').classList.toggle('disabled', isAtStart);
      scrollIndicators.querySelector('.scroll-right').classList.toggle('disabled', isAtEnd);
    }
    
    horizontalContainer.addEventListener('scroll', updateScrollIndicators);
    updateScrollIndicators();
  }
  
  // Add touch feedback for buttons
  const buttons = document.querySelectorAll('#section-{{ section.id }} .card-button');
  buttons.forEach(button => {
    button.addEventListener('touchstart', function() {
      this.style.transform = 'scale(0.97)';
    });
    
    button.addEventListener('touchend', function() {
      this.style.transform = '';
    });
  });
  
  // Optimize image loading
  if ('loading' in HTMLImageElement.prototype) {
    document.querySelectorAll('#section-{{ section.id }} img[loading="lazy"]').forEach(img => {
      img.onload = function() {
        this.classList.add('loaded');
      };
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
